<template>
  <div ref="elRef" class="flex flex-col sm:w-[552px] rounded-xl bg-white">
    <OArticleCard v-bind="$attrs" :article="data" class="flex flex-col w-full" :data-layer="datalayer">
      <OArticleCover class="w-full flex-shrink-0 rounded-t-md" />
      <div class="bg-white w-full flex flex-col flex-grow p-4 rounded-xl">
        <div class="flex flex-col flex-grow">
          <div class="flex mb-2">
            <OArticleHashtag class="leading-22 mr-auto z-2" />
            <OArticleCategory class="ml-auto z-2 text-[#9B9B9B]" />
          </div>
          <div class="flex-grow">
            <OArticleTitle
              target="_blank"
              :level="3"
              class="hover:text-link-primary line-clamp-3"
              @click.native="setClickLabel('İçerik')"
            />
            <OArticleDescription class="text-md leading-22 font-normal text-primary-200 line-clamp-2 tracking-tight mt-2" />
          </div>
          <OArticleComment class="mt-4 z-3" @click.native="setClickLabel('Yorum')" />
        </div>
        <div class="flex justify-between items-center mt-4">
          <OArticleDate slot="article_date" class="font-medium text-sm text-primary-200" />
          <div class="flex items-center space-x-3 text-sm font-medium z-3">
            <OArticleReactions />
            <OArticleFavorite v-if="menuType !== 'sana-ozel'" />
            <OArticleShare />
          </div>
        </div>
      </div>
    </OArticleCard>
  </div>
</template>

<script>
import { defineComponent, inject, ref } from '@nuxtjs/composition-api';
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import OArticleCategory from '@/modules/card/components/ArticleCategory';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';
import OArticleDescription from '@/modules/card/components/ArticleDescription';
import OArticleDate from '~/modules/card/components/ArticleDate';
import OArticleFavorite from '~/modules/card/templates/article/ArticleFavorite.vue';
import OArticleShare from '~/modules/card/templates/article/ArticleShare.vue';
import OArticleComment from '~/modules/card/components/ArticleComment.vue';
import OArticleReactions from '~/modules/card/templates/article/ArticleReactions.vue';
import { localStore } from '~/modules/common/utils/localStorageUtils';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleCategory,
    OArticleHashtag,
    OArticleDescription,
    OArticleDate,
    OArticleFavorite,
    OArticleShare,
    OArticleComment,
    OArticleReactions,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  inheritAttrs: false,

  setup(props) {
    const dataLayerName = inject('dataLayerName')?.value;
    const menuType = localStore.getItem('o-main-filter');

    const datalayer = ref({
      name: dataLayerName,
      position: 1,
      clickLabel: null,
      listId: 'Keşfet',
    });

    const setClickLabel = (label) => {
      datalayer.value.clickLabel = label;
    };

    return { datalayer, setClickLabel, menuType };
  },
});
</script>
